import {vue} from "../../../main";

export const guestFeatureRequestModule = {
    namespaced: true,
    state: {
        totalOfRequested: 0,
        timer: null,
    },
    getters: {
        totalOfRequested(state){
            return state.totalOfRequested;
        }
    },
    mutations: {
        totalOfRequested(state, total){
            state.totalOfRequested = total;
        },
        setTimer(state, timer){
            state.timer = timer;
        }
    },
    actions: {
        initTimer({commit, dispatch, state}){
            console.log("startPingSystem");
            if (state.timer != null) {
                return
            }
            dispatch('fetchTotalOfRequested');
            commit('setTimer', setInterval(() => dispatch('fetchTotalOfRequested'), 10*1000))
        },
        fetchTotalOfRequested(actions){
            return this.$api.baseApi().get('/realEstate/contract/feature/guest/get/requested', {params: {buids: actions.rootGetters['data/getSelectedBranchesIds'].join(",")}})
                .then(response => {
                    actions.commit('totalOfRequested', response.data?.objects.requests);
                    return response.data?.objects.requests;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchAllGuestFeatures(actions, {page, buids, amount, filter, sortcolumn, sortby}) {
            let params = {
                buids: (buids ||  actions.rootGetters['data/getSelectedBranchesIds']).join(","),
                page,
                amount,
                sortcolumn,
                sortby
            };
            return this.$api.baseApi().post('/realEstate/contract/feature/guest/get/all', filter, {params})
                .then(response => {
                    return response.data?.objects;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchGuestFeaturesByContactId(actions, contractId) {
            return this.$api.baseApi().get('/realEstate/contract/feature/guest/get/requests/' + contractId)
                .then(response => {
                    return response.data?.objects.features;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchAllGuestFeatureByContactId(actions, contractId) {
            return this.$api.baseApi().get('/realEstate/contract/feature/guest/get/allowed/' + contractId)
                .then(response => {
                    return response.data?.objects.features;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        getGuestFeaturesByContactId(actions, requestsId) {
            return this.$api.baseApi().get('/realEstate/contract/feature/guest/get/request/' + requestsId)
                .then(response => {
                    return response.data?.objects.feature;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        updateGuestFeaturesToContactId(actions, {featureId, request}) {
            return this.$api.baseApi().post('/realEstate/contract/feature/guest/update/' + featureId, request)
                .then(response => {
                    return response.data?.objects;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        addGuestFeaturesToContactId(actions, {contractId, request}) {
            return this.$api.baseApi().post('/realEstate/contract/feature/guest/add/' + contractId, request)
                .then(response => {
                    return response.data?.objects;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        cancelGuestFeaturesByContactId(actions, requestsId) {
            return this.$api.baseApi().get('/realEstate/contract/feature/guest/cancel/' + requestsId)
                .then(response => {
                    return response.data?.objects.RequestedFeature;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['feature']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        generateOrderForContract(actions, contractId) {
            return this.$api.baseApi().get('/realEstate/contract/feature/guest/order/' + contractId)
                .then(response => {
                    return response.data?.objects.Order;
                }).catch(error => {
                    if (error?.response?.status === 404) {
                        actions.dispatch('notifications/error',
                            {
                                title: {text: '%s - failed to retrieve', arguments: ['feature']},
                                message: 'No features available for this contract'
                            },
                            {root: true});
                    } else {
                        actions.dispatch('notifications/error',
                            {
                                title: {text: '%s - failed to retrieve', arguments: ['feature']},
                                // message: (typeof error === "object" && error.response !== undefined ? error.response.data : error)
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                    }
                    throw error;
                });
        },
        payOrderForContract(actions, { orderId, request }) {
            return this.$api.baseApi()
                .post('/realEstate/contract/feature/guest/order/pay/' + orderId, request)
                .then(response => {

                    const res = response.data;

                    // --- SUCCESS HANDLING ---
                    if (res.status === true) {
                        actions.dispatch(
                            'notifications/success',
                            {
                                title: { text: '%s - success', arguments: ['Payment'] },
                                message: res.message || 'Success'
                            },
                            { root: true }
                        );

                        return res.objects?.Order || null;
                    }

                    // --- LOGICAL FAILURE (status=false but HTTP 200) ---
                    actions.dispatch(
                        'notifications/error',
                        {
                            title: { text: '%s - failed', arguments: ['Payment'] },
                            message: res.message || 'Payment failed'
                        },
                        { root: true }
                    );

                    return null;
                })
                .catch(error => {

                    // --- NETWORK / SERVER ERROR (non-200) ---
                    const msg =
                        error?.response?.data?.message ||
                        error?.message ||
                        'Unknown error';

                    actions.dispatch(
                        'notifications/error',
                        {
                            title: { text: '%s - error', arguments: ['Payment'] },
                            message: msg
                        },
                        { root: true }
                    );

                    return null;
                });
        }

    }
}
